<template>
    <fb-form-properties-manager id="text-input-ai-autofill-v1-properties-de2plu" :fields="fields" :formId="formId" />
  </template>
  
  <script>

  export default {
    name: "TextInputAiAutofillV1Properties",
    props: ["formId", "options"],
    data() {
      return {
        fields: [
          {
            type: "dropdown",
            properties: {
              label: "Ai generated field",
              options: this.options,
              updateAiLabel: true
            },
            property: "sectionSelected"
          },
          {
            type: "textInput",
            properties: {
              label: "Label"
            },
            property: "label"
          },
          {
            type: "textInput",
            properties: {
              label: "Placeholder"
            },
            property: "placeholder"
          },
          {
            type: "textInput",
            properties: {
              label: "Description"
            },
            property: "description"
          },
          {
            type: "textInput",
            properties: {
              label: "Default value"
            },
            property: "value"
          },
          {
            type: "checkbox",
            properties: {
              label: "Required",
              disabled: element => {
                return !(element.properties.hidden == false || element.properties.hidden == "{{!(true)}}");
              }
            },
            property: "required"
          },
          {
            type: "textInput",
            properties: {
              label: "Min length",
              type: "number"
            },
            property: "minLength"
          },
          {
            type: "textInput",
            properties: {
              label: "Max length",
              type: "number"
            },
            property: "maxLength"
          },
          {
            type: "checkbox",
            properties: {
              label: "Editable in Patient Portal"
            },
            property: "eFormEditable"
          },
          {
            type: "conditionEditor",
            properties: {
              label: "Visibility condition",
              updateValueMiddleware: (value) => {return value.replace("{{(","{{!(")}
            },
            property: "hidden"   
          }
        ]
      };
    }
  };
  </script>
  
  <style></style>
  